// extracted by mini-css-extract-plugin
export var listStyle = "styles-module--listStyle--3D5wY";
export var blockquote = "styles-module--blockquote--2YMQ9";
export var highlight = "styles-module--highlight--2DE5p";